import { defineComponent } from 'vue';
import LaserDebug from '../../RoomDebug/LaserDebug.vue';
export default defineComponent({
    name: 'GridRoomControl',
    components: {
        LaserDebug
    },
    props: {
        roomid: {
            type: String,
            required: true
        }
    },
    computed: {
        status() {
            return this.$store.direct.state.rooms.status[this.roomid];
        },
        lasers() {
            return this.status.lasers;
        }
    },
    methods: {
        updateLasers(payload) {
            this.status.lasers = JSON.parse(payload.value);
            this.$store.direct.dispatch.rooms.setLaser({
                roomid: this.roomid,
                laser: payload.name,
                value: payload.value,
            });
        },
        updateButtons(payload) {
            console.log('Updating button', payload);
            this.$store.direct.dispatch.rooms.setButton({
                roomid: this.roomid,
                button: payload.name,
                value: payload.value,
            });
        }
    }
});
